import { O365AuditWebController } from '../controller/O365AuditWebController';
import { SensorType } from '../../types/sensor-type';
import { BaseSensorWebComponent } from '../../base/BaseSensorWebComponent';

export class O365AuditWebComponent extends BaseSensorWebComponent {
  public controller!: O365AuditWebController;

  constructor() {
    super();
    this.sensorType = SensorType.O365_AUDIT;
    this.initialSetup({
      controllerConstructor: O365AuditWebController,
    });
  }
}
